// extracted by mini-css-extract-plugin
export default {"notFound":"styles_notFound__18M7Z","wrapper":"styles_wrapper__Oowng"};